import Swiper, {Autoplay} from 'swiper';

export class PartnersComponent {
  config = {
    slidesPerView: 'auto',
    spaceBetween: 20,
    loop: true,
    autoplay: {
      delay: 2000
    },
    breakpoints: {
      0: {
        spaceBetween: 7,
        slidesPerView: 3
      },
      768: {
        spaceBetween: 20,
        slidesPerView: 3
      },
      960: {
        slidesPerView: 4
      },
      1120: {
        slidesPerView: 5
      },
      1280: {
        slidesPerView: 6
      },
      1440: {
        slidesPerView: 7
      },
      1600: {
        slidesPerView: 8
      },
      1760: {
        slidesPerView: 9
      },
      1920: {
        slidesPerView: 10
      }
    }
  };

  container = document.querySelector('.partners-carousel  .elementor-column');

  swiper = null;

  constructor() {
    if (!this.container) {
      return;
    }

    this.initialize();

    this.addEventListeners();
  }

  initialize() {
    Swiper.use([Autoplay]);
    this.toggleDesktopClass();
    this.createCarousel();
  }

  addEventListeners() {
    window.addEventListener('resize', (e) => this.windowResizeHandler(e));
  }

  windowResizeHandler(e) {
    this.toggleDesktopClass();
  }

  toggleDesktopClass() {
    const container = this.container;

    window.outerWidth >= 768
      ? container.classList.add('desktop')
      : container.classList.remove('desktop');
  }

  createCarousel() {
    if (this.swiper) {
      return;
    }

    const container = this.container;
    if (!container) {
      return;
    }

    container.classList.add('swiper-container');

    const wrapper = container.querySelector('.elementor-widget-wrap');
    if (!wrapper) {
      return;
    }

    wrapper.classList.add('swiper-wrapper');

    const items = wrapper.getElementsByClassName('partners-carousel__item');
    if (items.length) {
      Array.from(items).forEach((item) => {
        item.classList.add('swiper-slide');
      });
    }

    this.swiper = new Swiper(container, this.config);
  }
}